/**
 * 다크/라이트 테마 스토어 — localStorage 에 영속.
 * html.light 클래스로 globals.css 의 CSS 변수 오버라이드를 트리거.
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ThemeMode = 'dark' | 'light'

interface ThemeState {
  mode: ThemeMode
  toggle: () => void
  setMode: (m: ThemeMode) => void
}

const applyToDom = (mode: ThemeMode) => {
  if (typeof document === 'undefined') return
  if (mode === 'light') {
    document.documentElement.classList.add('light')
  } else {
    document.documentElement.classList.remove('light')
  }
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      mode: 'light',
      toggle: () => {
        const next = get().mode === 'dark' ? 'light' : 'dark'
        applyToDom(next)
        set({ mode: next })
      },
      setMode: (m) => {
        applyToDom(m)
        set({ mode: m })
      },
    }),
    {
      name: 'saife-theme',
      onRehydrateStorage: () => (state) => {
        if (state) applyToDom(state.mode)
      },
    },
  ),
)
